import { logCopilotChatSidePaneTelemetryEvent } from "owa-copilot-telemetry/lib/copilotChatSidePaneTelemetryLogger";
import { setUserPreferredWidthMutator } from "../mutators/setUserPreferredWidthMutator";
import { onCopilotChatDrawerLayoutChange } from "../actions/onCopilotChatDrawerLayoutChange";
import { MINIMUM_COPILOT_CHAT_DRAWER_WIDTH } from "../utils/copilotChatDrawerConstants";
import { onCopilotChatDrawerCollapsedState } from "../actions/onCopilotChatDrawerCollapsedState";
import { onCopilotChatDrawerExpandedState } from "../actions/onCopilotChatDrawerExpandedState";
import type { MailboxInfo } from "owa-client-types";
import { saveCopilotChatDrawerWidth } from "../utils/copilotChatDrawerLocalStorage";

/**
 * Function to handle the click-and-drag resizing of the Copilot Chat Drawer.
 * @param targetWindow The target window
 * @param newWidth The new width of the Copilot Chat Drawer.
 * @param mailboxInfo MailboxInfo for the account. If not provided, falls back to getModuleContextMailboxInfo().
 */
export function resizeCopilotChatDrawer(targetWindow: Window, newWidth: number, mailboxInfo?: MailboxInfo): void {
    setUserPreferredWidthMutator(targetWindow, newWidth);
    saveCopilotChatDrawerWidth(targetWindow, newWidth);
    logCopilotChatSidePaneTelemetryEvent("CopilotSidePane_UserResized", {}, mailboxInfo);
    if (newWidth <= MINIMUM_COPILOT_CHAT_DRAWER_WIDTH) {
        onCopilotChatDrawerCollapsedState(targetWindow);
    }
    else {
        onCopilotChatDrawerExpandedState(targetWindow);
    }
    if (targetWindow === window) {
        onCopilotChatDrawerLayoutChange();
    }
}
